import type { Platform } from './types';

export const PLATFORM_NAMES: Record<Platform, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'Twitter',
  linkedin: 'LinkedIn',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  pinterest: 'Pinterest',
  google_my_business: 'Google My Business',
  threads: 'Threads',
};

export const STEP_LABELS = {
  page_selection: 'Select Pages',
  bulk_assignment: 'Assign Posts',
  review: 'Review',
  scheduling: 'Scheduling',
  results: 'Results',
} as const;

export const STEP_ORDER: Array<keyof typeof STEP_LABELS> = [
  'page_selection',
  'bulk_assignment',
  'review',
  'scheduling',
  'results',
];
